import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Mi estis libera kaj plenpova, mi ŝvebis super nuboj, ludante kun vento.
    </p>
    
    <p class="mb-3">
      Neniu egalas min, mi estas la sola reganto de Subĉielo. 
      Sed ho! 
      Aperis de la sudo rivalo, kiu ankaŭ deziras regi la aeron kaj ĉiam rikanas min. 
      Sed ĉi-foje li ne evitos punon. 
      Atako, ankoraŭ atako! Li falas teren, disŝirita de miaj ungegoj.
    </p>
    
    <p class="mb-3">
      La venko! Mi jubilas, flosante en aeraj ondoj sub suna brilo.
    </p>
    
    <p class="mb-3">
      Sed jen subite io tiras min teren. 
      De la pinto de ĝojo mi estas krude ĵetita al tero. 
      Oni prenas min, faldas kaj portas al la domo, kie denove metas en malluman keston.
    </p>
    
    <p class="mb-3">
      Mi estas kajto.
    </p>
    `
  )
}

const itemName = {
  esp: 'Libero'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;